import { render, staticRenderFns } from "./saas_withdraw_apply_detail.vue?vue&type=template&id=64438456&scoped=true"
import script from "./saas_withdraw_apply_detail.vue?vue&type=script&lang=js"
export * from "./saas_withdraw_apply_detail.vue?vue&type=script&lang=js"
import style0 from "./saas_withdraw_apply_detail.vue?vue&type=style&index=0&id=64438456&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64438456",
  null
  
)

export default component.exports